exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-tooltip .vue-tooltip-arrow[data-v-4423ea72] {\n  display: none;\n}\n.vue-tooltip .vue-tooltip-inner[data-v-4423ea72] {\n  max-width: 300px;\n  opacity: 0.9;\n  background: #616161;\n}\n.v-dialog__content[data-v-4423ea72] {\n  z-index: 1030 !important;\n}", ""]);

// exports
